<div class="wrapper" *ngIf="vm$ | async as vm">
  <div class="logo-wrapper desktop-logo">
    <a href="https://pivot-payment.com" target="_blank" rel="noopener noreferrer">
      <lib-logo variant="normal" size="medium" [customWidth]="'112px'"></lib-logo>
    </a>
  </div>

  <div class="session">
    <div class="mobile-logo">
      <lib-logo variant="white" size="small" [customWidth]="'112px'"></lib-logo>
    </div>
    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <h4 class="desktop-title">Welcome back!</h4>
      <h4 class="mobile-title">Welcome Back to Pivot!</h4>
      <span class="desktop-subtitle">Please enter your registered email and password</span>
      <div class="input-form">
        <label for="email">Email <span class="required">*</span></label>
        <lib-input
          type="text"
          formControlName="email"
          [error]="
            loginForm.get('email')?.hasError('required') && loginForm.get('email')?.touched
              ? 'Email is required.'
              : loginForm.get('email')?.hasError('email') && loginForm.get('email')?.touched
                ? 'Invalid email format.'
                : ''
          "
          placeholder="Exp name@mail.com"
        >
        </lib-input>
      </div>
      <div class="input-form">
        <div class="password-lable">
          <label for="password">Password <span class="required">*</span></label>
          <a [routerLink]="['/forgot-password']" routerLinkActive="router-link-active"
            >Forget Password?</a
          >
        </div>
        <lib-input
          [type]="passwordFieldType"
          name="password"
          id="password"
          autocomplete="off"
          [iconRight]="passwordEyeTemplate"
          formControlName="password"
          [error]="
            loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched
              ? 'Password is required.'
              : vm.errorMessage
                ? vm.errorMessage
                : ''
          "
          placeholder="Input password here"
          (onIconRightClick)="togglePasswordType()"
        ></lib-input>
      </div>
      <div
        class="input-form remember-me"
        [class.checkbox-hidden]="vm?.isDeviceRecognized"
        [@slideCollapse]="vm?.isDeviceRecognized ? 'collapsed' : 'expanded'"
      >
        <lib-checkbox
          formControlName="isRemember"
          [binary]="true"
          [label]="'Remember this device for 30 days'"
          name="group"
        />
      </div>
      <lib-button
        gtmTrackClick
        [gtmEvent]="GTMEventType.LOGIN_PAGE"
        [gtmCategory]="GTMEventCategory.BUTTON"
        [gtmEmail]="loginForm.get('email')?.value"
        [disabled]="loginForm.invalid"
        width="100%"
        style="width: 130px"
      >
        Log in
      </lib-button>

      <p class="contact-sales">
        Don’t have an account?
        <a href="https://pivot-payment.com/contact-sales?utm_source=dashboard&utm_medium=internal">
          Contact Sales
        </a>
      </p>
    </form>
  </div>
  <app-block-loading [show]="vm.isLoading"></app-block-loading>
  <app-otp
    [hidden]="!vm.isOtpRequired"
    [displayOtpDialog]="vm.isOtpRequired"
    (dialogChange)="disableOtpRequire()"
    [countDownStarted]="vm.isCountDownStarted"
    [resendDelaySeconds]="vm.resendDelaySeconds"
    [twoFactorAuthMethod]="vm.twoFactorAuthMethod"
    mode="dialog"
  ></app-otp>

  <div class="testimonial-wrapper">
    <app-testimonial></app-testimonial>
  </div>
</div>

<!-- Eye icon templates -->
<ng-template #passwordEyeTemplate>
  <lib-icons [name]="passwordEyeIconName" category="system"></lib-icons>
</ng-template>
